import { render, staticRenderFns } from "./GroupAttach.vue?vue&type=template&id=c4424b04"
import script from "./GroupAttach.vue?vue&type=script&lang=js"
export * from "./GroupAttach.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports